export default __webpack_public_path__ + "2e5fa29cd4b830ef9db9c7a73e9e3a8a.ply";